var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3Dot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5556_302973",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 4,
    width: 4,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.25C12.8684 7.25 13.5 6.61842 13.5 5.75C13.5 4.88158 12.7895 4.25 12 4.25C11.1316 4.25 10.5 4.88158 10.5 5.75C10.5 6.61842 11.2105 7.25 12 7.25ZM12 10.5C11.1316 10.5 10.5 11.1316 10.5 12C10.5 12.8684 11.2105 13.5 12 13.5C12.8684 13.5 13.5 12.8684 13.5 12C13.5 11.1316 12.8684 10.5 12 10.5ZM10.5 18.25C10.5 17.3816 11.1316 16.75 12 16.75C12.8684 16.75 13.5 17.3816 13.5 18.25C13.5 19.1184 12.8684 19.75 12 19.75C11.2105 19.75 10.5 19.1184 10.5 18.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5556_302973)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#010101"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Dot);
export default __webpack_public_path__ + "static/media/3dot.42e4f9f38952f990abd631da7ee81d80.svg";
export { ForwardRef as ReactComponent };